// @flow
import * as React from "react"
import type { HOC } from "recompose"
import withLocation from "hoc/withLocation"
import { StyledHref, StyledNavLink } from "./styled"

const StyledLink = ({ children, draggable = "true", to, className, onClick, exact, underline }) => {
  // mails and phones
  if (!to || to.startsWith("mailto:") || to.startsWith("tel:"))
    return (
      <StyledHref href={to} className={className} onClick={onClick} draggable={draggable}>
        {children}
      </StyledHref>
    )

  // external links
  if (to.startsWith("http") || to.startsWith("www."))
    return (
      <StyledHref
        href={to}
        rel="noreferrer noopener"
        target="_blank"
        className={className}
        onClick={onClick}
        draggable={draggable}
      >
        {children}
      </StyledHref>
    )

  // everything else
  return (
    <StyledNavLink
      to={to}
      className={className}
      activeClassName="active"
      onClick={onClick}
      exact={exact}
      draggable={draggable}
      underline={underline}
    >
      {children}
    </StyledNavLink>
  )
}

type Outter = {|
  children: React.Node,
  to?: string,
  onClick?: Function,
  exact?: boolean,
  // injected from styled components
  className?: string,
  draggable?: string,
  underline?: boolean,
|}

// to ensure a link is rerendered on location change
const enhancer: HOC<*, Outter> = withLocation()

export default enhancer(StyledLink)



// WEBPACK FOOTER //
// ./src/components/StyledLink/index.js